/** 見出しがこの距離までスクロール領域の上端に近づいたら、その節に入ったとみなす。 */
export const CURRENT_HEADING_OFFSET = 24;

/**
 * 今いる節の見出しの番号を返す。どの見出しにも入っていなければ -1。
 * headingTops はスクロール領域の上端から各見出しの上端までの距離 (出現順)。
 */
export function currentHeadingIndex(
	headingTops: readonly number[],
	scrolledToBottom: boolean,
	offset = CURRENT_HEADING_OFFSET,
): number {
	if (headingTops.length === 0) return -1;
	if (scrolledToBottom) return headingTops.length - 1;
	return headingTops.findLastIndex((top) => top <= offset);
}
